export default __webpack_public_path__ + "static/media/hosted-graphite.a03a50e9.svg";